var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('iframe',{attrs:{"src":"https://gecevicius.lt/Projects/TextGame/","width":"90%","height":"90%"}})])
}]

export { render, staticRenderFns }